import React, { useState } from 'react';
import { Box, Typography, Paper, Container, Avatar, Menu, MenuItem, Button, Divider } from '@mui/material';
import { useAuth } from './AuthContext';

function Header({ onLoginClick, showImage = true }) {
  const { user, logout, adminDisplayEnabled, toggleAdminDisplay } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: 'transparent',
        borderRadius: 0,
        pb: 3,
      }}
    >
      <Container maxWidth={false} sx={{ px: 2, maxWidth: '900px', mx: 'auto' }}>
        <Box 
          sx={{ 
            pt: 1.65, 
            pb: 0.275,
            backgroundColor: 'transparent',
            borderRadius: 2,
            opacity: 1,
            mt: 3,
            mb: 0.25,
            maxWidth: '100%',
          }}
        >
          {showImage && (
            <Box
              sx={{
                width: '100%',
                margin: '0 auto 20px',
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 4,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'transparent',
              }}
            >
              <img
                src="/james_natalie_golf_opt.jpg"
                alt="James & Natalie Golf"
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  objectFit: 'contain',
                }}
              />
            </Box>
          )}
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} flexDirection="row-reverse" position="relative">
            <Box
              sx={{
                color: 'white',
                textAlign: 'right',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                gap: 0.25,
                position: 'relative',
              }}
            >
              <Box
                component="h1"
                sx={{
                  display: 'flex',
                  alignItems: 'baseline',
                  gap: 0.5,
                  lineHeight: 1.2,
                  margin: 0,
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontFamily: '"Impact", "Arial Black", "Helvetica Neue", sans-serif',
                    fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                    fontWeight: 900,
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    color: 'white',
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                  }}
                >
                  JAMALIE
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    fontFamily: '"Trebuchet MS", "Comic Sans MS", "Arial Rounded MT Bold", sans-serif',
                    fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                    fontWeight: 700,
                    letterSpacing: '0.02em',
                    textTransform: 'uppercase',
                    color: '#FFD700',
                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                    fontStyle: 'italic',
                  }}
                >
                  CUP
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontFamily: '"Georgia", "Times New Roman", serif',
                  fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' },
                  fontWeight: 400,
                  fontStyle: 'italic',
                  color: 'rgba(255, 255, 255, 0.85)',
                  textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                  letterSpacing: '0.03em',
                  lineHeight: 1.3,
                  mt: 0.25,
                }}
              >
                Dec 13th, 6PM pregame @Captured, 7PM @ Alto
              </Typography>
            </Box>
            <Box display="flex" alignItems="center" gap={1}>
              {user ? (
                <Avatar 
                  src={user.picture} 
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                  sx={{ 
                    width: 90, 
                    height: 90, 
                    border: '2px solid', 
                    borderColor: 'primary.main',
                    cursor: 'pointer',
                    '&:hover': {
                      opacity: 0.8,
                    },
                  }}
                >
                  {user.name?.[0]}
                </Avatar>
              ) : (
                <Button
                  variant="outlined"
                  onClick={onLoginClick}
                  sx={{
                    color: 'white',
                    borderColor: 'white',
                    '&:hover': {
                      borderColor: 'white',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                  }}
                >
                  Sign In
                </Button>
              )}
            </Box>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              {user?.is_admin && (
                <>
                  <MenuItem 
                    onClick={() => {
                      toggleAdminDisplay();
                      setAnchorEl(null);
                    }}
                  >
                    {adminDisplayEnabled ? 'Hide Admin Display' : 'Show Admin Display'}
                  </MenuItem>
                  <Divider />
                </>
              )}
              {user ? (
                <MenuItem onClick={() => {
                  setAnchorEl(null);
                  logout();
                }}>Logout</MenuItem>
              ) : (
                <MenuItem onClick={() => {
                  setAnchorEl(null);
                  onLoginClick();
                }}>Sign In</MenuItem>
              )}
            </Menu>
          </Box>
        </Box>
      </Container>
    </Paper>
  );
}

export default Header;
